/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import MidiaService from '../../../../services/tvs/midiaServices.js';
import { ProgressSpinner } from 'primereact/progressspinner';

export function VisualizarMidia({
    rowSelecionada,
    dadosGrupo,
    modalVincularTVAberto,
    setModalVincularTVAberto
    
}) {
    const [imagem, setImagem] = useState('');
    const [imagems, setImagems] = useState(true);
    const [loand, setLoand] = useState(false);    

    useEffect(() => {
        (async () => {
            setLoand(true);
            setImagems(true);
            
            setImagem('');

            const { data: { url } } = await MidiaService.buscarMidiaUrl({
                url: rowSelecionada.path  
            });
            
            setImagem(url);

            if(url.indexOf('mp4') > 0) { setImagems(false);}
            
            setLoand(false);
        })();
    }, [rowSelecionada]);

    const Video = (
        <video width="100%" controls>       
            <source type="video/mp4" src={imagem} ></source>
        </video>
    );

    const Img = (              
        <img style={{ width: '100%' }} src={imagem} ></img>      
    );
        
    return (
        <>            
            <Dialog style={{ width: '80vw' }} 
                header={'Visualizar midia'} 
                visible={modalVincularTVAberto}
                onHide={setModalVincularTVAberto.bind(this,false)} >
                {loand ? <div className="p-col size-spinner">  <ProgressSpinner /></div>  : 
                    <div className="p-grid p-fluid">
                        {imagems ? Img : Video }
                    </div>
                }            
            </Dialog>            
        </>
    );
}
